import { render, staticRenderFns } from "./curSale-delivery-list.vue?vue&type=template&id=74fcdb11&scoped=true"
import script from "./curSale-delivery-list.vue?vue&type=script&lang=js"
export * from "./curSale-delivery-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fcdb11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74fcdb11')) {
      api.createRecord('74fcdb11', component.options)
    } else {
      api.reload('74fcdb11', component.options)
    }
    module.hot.accept("./curSale-delivery-list.vue?vue&type=template&id=74fcdb11&scoped=true", function () {
      api.rerender('74fcdb11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/curSale-management/curSale-delivery/curSale-delivery-list.vue"
export default component.exports